import { createContext } from 'react';
import moment from 'moment';

import WeekHelper from '../functions/WeekHelper';
import { COVERING_TABLE_BOSS_NAME_COL, COVERING_TABLE_EMP_NAME_COL, COVERING_TABLE_EMP_SKILL_COL, COVERING_TABLE_OFFICE_COL, COVERING_TABLE_REGION_NAME_COL, COVERING_TABLE_STATUS_COL, EMP_IS_WORKING, EMP_WILL_START, COVERING_TABLE_AVAILABLE_NEXT_FIVE_WEEKS_OPT, SHOW_ALL } from '../i18n/keyConstants';
import { coveringAvailabilityOptions,employeeStatusOptions } from '../components/exl/shared/translations';
import { createDateFromWeekNumber, getLabelAndValueFromUrl, convertFiltersToString, getLabelsAndValuesFromFilterType, getSingleFilterColumn, getValueFromUrl } from '../components/tables/covering/CoveringHelperFunctions';

const defaultColumns = [
    { title: COVERING_TABLE_EMP_NAME_COL, name: 'empName' },
    { title: COVERING_TABLE_EMP_SKILL_COL, name: 'empSkill' },
    { title: COVERING_TABLE_OFFICE_COL, name: 'office' },
    { title: COVERING_TABLE_REGION_NAME_COL, name: 'regionName' },
    { title: COVERING_TABLE_STATUS_COL, name: 'status' },
    { title: COVERING_TABLE_BOSS_NAME_COL, name: 'bossName' },
    //{ title: 'Interntimmar', name: 'empIntHours' },
];

const defaultHiddenColumns = ['bossName', 'regionName', 'status'];

const dateCurrWeek = new Date();
const dateEndWeek = WeekHelper.GetMondayDateOfWeek(
    WeekHelper.AddWeeks(dateCurrWeek.getFullYear() + WeekHelper.ToStringLeadingZeroes(moment(dateCurrWeek).isoWeek(), 2), 11)
);

const selectedFilters = { empName: getSingleFilterColumn('empName'), empSkill: getSingleFilterColumn('empSkill'), bossName: getSingleFilterColumn('bossName') };

const tableColumnExtensions = [
    { columnName: 'empName', width: 230, align: 'left' },
    { columnName: 'bossName', width: 230, align: 'left' },
    //{ columnName: 'empIntHours', width: 250, align: 'left' },
    { columnName: 'empSkill', width: 170, align: 'left' },
    { columnName: 'office', width: 230, align: 'left' },
    { columnName: 'regionName', width: 230, align: 'left' },
    { columnName: 'status', width: 230 },
];

export const initialState = {
    coverings: [],
    filters: convertFiltersToString('filters') || [{ columnName: 'status', operation: 'equal', value: 'isWorkingORwillStart' }],
    requestUri: null,
    filterByBossEmpId: getValueFromUrl('filterByBossEmpId'),
    defaultFilters: convertFiltersToString('filters') || [{ columnName: 'status', operation: 'equal', value: 'isWorkingORwillStart' }],
    descriptionFilters: convertFiltersToString('descriptionFilters') || [''],
    descriptionSearchSuggestions: [],
    hiddenColumns: defaultHiddenColumns,
    showCustomCols: false,
    columnName: 'empName',
    tableSize: 0,
    direction: 'asc',
    pageSize: 25,
    currentPage: 1,
    expandedRowIDs: [],
    columnSortingExtensions: [],
    isLoading: true,
    error: null,
    columns: defaultColumns,
    noWeeksColumns: defaultColumns,
    columnBands: [],
    weekWidth: 100,
    availableDates: [],
    bltIDNames: [],
    latestDate: null,
    selectedDate: new Date(),
    startWeek: createDateFromWeekNumber('startWeek') || dateCurrWeek,
    endWeek: createDateFromWeekNumber('endWeek') || dateEndWeek,
    selectedOccupancy:
        getLabelAndValueFromUrl('occupancyCheck', coveringAvailabilityOptions) ||
        { label: COVERING_TABLE_AVAILABLE_NEXT_FIVE_WEEKS_OPT, value: 'availableNextFiveWeeks' },
    selectedOffice: null,
    selectedRegion: null,
    selectedFilters: selectedFilters,
    isResettingFilters: false,
    selectedStatus:
        getLabelsAndValuesFromFilterType('status', employeeStatusOptions) ||
        [
            { label: EMP_IS_WORKING, value: 'isWorking' },
            { label: EMP_WILL_START, value: 'willStart' },
        ],
    tableColumnExtensions,
    defaultTableColumnExtensions: tableColumnExtensions,
    // TODO: Fetch with initial getAvailableDates call from server
    bltIDToNames: {
        UP: 'Uppdrag',
        SM: 'Semester',
        FL: 'Föräldraledig',
        TL: 'Tjänsteledig',
    },
    isSavedToastOpen: false,
    isDeletedToastOpen: false,
};

export const reducer = (state, action) => {
    switch (action.type) {
        case 'FETCH_SUCCESS':
            return {
                ...state,
                coverings: action.coverings,
                tableSize: action.totalRows,
                columnBands: action.columnBands,
                isLoading: false,
                columns: defaultColumns.concat(action.columns),
                columnSortingExtensions: action.columnSortingExtensions,
                availableDates: action.availableDates,
                expandedRowIDs: [],
                descriptionSearchSuggestions: action.descriptionSearchSuggestions,
                filterByBossEmpId: action.filterByBossEmpId,
            };
        case 'FETCH_DATA_SUCCESS':
            return {
                ...state,
                availableDates: action.availableDates,
                selectedDate: action.selectedDate,
                latestDate: action.latestDate,
                BltIDNames: action.BltIDNames,
            };
        case 'FETCH_ERROR':
            return {
                ...state,
                error: action.payload,
                isLoading: false,
            };
        case 'FETCH_DATES_ERROR':
            return {
                ...state,
                error: action.payload,
            };
        case 'UPDATE_REMARKS_COVERINGS':
            return {
                ...state,
                coverings: action.payload,
            };
        case 'SET_ISLOADING_TRUE':
            return {
                ...state,
                isLoading: true,
            };
        case 'SET_ISLOADING_FALSE':
            return {
                ...state,
                isLoading: false,
            };
        case 'FILTERS':
            return {
                ...state,
                filters: action.payload,
                defaultFilters: action.payload,
                currentPage: 1,
            };
        case 'DESCRIPTION_FILTERS':
            return {
                ...state,
                descriptionFilters: action.payload,
            };
        case 'SET_REQUEST_URI':
            return {
                ...state,
                requestUri: action.payload,
            };
        case 'RESET_FILTERS':
            return {
                ...state,
                filters: [{ columnName: 'status', operation: 'equal', value: 'isWorkingORwillStart' }],
                defaultFilters: [{ columnName: 'status', operation: 'equal', value: 'isWorkingORwillStart' }],
                descriptionFilters: [''],
                currentPage: 1,
                selectedOffice: null,
                selectedRegion: null,
                selectedStatus: [
                    { label: EMP_IS_WORKING, value: 'isWorking' },
                    { label: EMP_WILL_START, value: 'willStart' },
                ],
                selectedOccupancy: { label: SHOW_ALL, value: 'all' },
                isResettingFilters: true,
            };
        case 'FILTERS_RESET':
            return {
                ...state,
                isResettingFilters: false,
            };
        case 'PAGESIZE':
            return {
                ...state,
                pageSize: action.payload,
            };
        case 'HIDDEN_COLUMNS':
            return {
                ...state,
                hiddenColumns: action.payload,
            };
        case 'RESET_HIDDEN_COLUMNS':
            return {
                ...state,
                hiddenColumns: defaultHiddenColumns,
                showCustomCols: false,
            };
        case 'SHOW_CUSTOM_COLS':
            return {
                ...state,
                showCustomCols: action.payload,
            };
        case 'HIDDEN_COLUMNS_AND_CUSTOM_COLS':
            return {
                ...state,
                hiddenColumns: action.hiddenColumns,
                showCustomCols: action.showCustomCols,
            };
        case 'CURRENT_PAGE':
            return {
                ...state,
                currentPage: action.payload,
            };
        case 'SORT_INFO':
            return {
                ...state,
                columnName: action.columnName,
                direction: action.direction,
                currentPage: 1,
            };
        case 'UPDATE_ROW_DETAILS':
            return {
                ...state,
                expandedRowIDs: action.payload,
            };
        case 'DATE_UPDATE':
            return {
                ...state,
                selectedDate: action.selectedDate,
            };
        case 'LATEST_DATE_UPDATE':
            return {
                ...state,
                latestDate: action.latestDate,
            };
        case 'DATE_UPDATE_AND_LATEST_DATE_UPDATE':
            return {
                ...state,
                selectedDate: action.payload,
                latestDate: action.payload,
            };
        case 'WEEK_UPDATE':
            return {
                ...state,
                startWeek: action.startWeek,
                endWeek: action.endWeek,
            };
        case 'SELECTED_OCCUPANCY':
            return {
                ...state,
                selectedOccupancy: action.payload,
                currentPage: 1,
            };
        case 'SELECTED_OFFICE':
            return {
                ...state,
                selectedOffice: action.payload,
            };
        case 'SELECTED_REG':
            return {
                ...state,
                selectedRegion: action.payload,
            };
        case 'SELECTED_FILTERS':
            return {
                ...state,
                selectedFilters: Object.assign(selectedFilters, { [action.columnName]: action.payload }),
            };
        case 'SELECTED_FILTERS_AND_FILTERS_RESET':
            return {
                ...state,
                selectedFilters: Object.assign(selectedFilters, { [action.columnName]: action.payload }),
                isResettingFilters: false,
            };
        case 'FILTERS_AND_SELECTED_FILTERS':
            return {
                ...state,
                filters: action.payload,
                defaultFilters: action.payload,
                currentPage: 1,
                selectedFilters: Object.assign(selectedFilters, { [action.columnName]: action.columnNameVal }),
            };
        case 'SELECTED_STATUS':
            return {
                ...state,
                selectedStatus: action.payload,
            };
        case 'RESET_COLS':
            return {
                ...state,
                hiddenColumns: defaultHiddenColumns,
            };
        case 'UPDATE_COVERINGS':
            return {
                ...state,
                coverings: action.coverings,
            };
        case 'SHOW_SAVED_TOAST':
            return {
                ...state,
                isSavedToastOpen: true,
            };
        case 'SHOW_DELETED_TOAST':
            return {
                ...state,
                isDeletedToastOpen: true,
            };
        case 'CLOSE_SAVED_TOAST':
            return {
                ...state,
                isSavedToastOpen: false,
            };
        case 'CLOSE_DELETED_TOAST':
            return {
                ...state,
                isDeletedToastOpen: false,
            };
        default:
            return state;
    }
};

export const DataContext = createContext(initialState);
